export default __webpack_public_path__ + "static/media/img-not-found.6c81e116.png";